import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStore } from '@doctor-scheduling/web/state';
import { filter, map, of, switchMap, take } from 'rxjs';

/**
 * Allows access only when the user is authenticated; otherwise redirects to login.
 * Waits for startup session restore and retries once when a refresh token is still present
 * (covers Nest API restarts during local development).
 * @returns Observable that emits true when authenticated, or a login UrlTree
 */
export const authGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  return toObservable(authStore.isInitialized).pipe(
    filter((ready) => ready),
    take(1),
    switchMap(() => {
      if (authStore.isAuthenticated()) {
        return of(true);
      }
      return authStore.ensureSession().pipe(
        map((ok) => (ok ? true : router.createUrlTree(['/auth/login'])))
      );
    })
  );
};
